import { useCallback, useEffect, useRef, useState } from "react";

const HIGHLIGHT_DURATION_MS = 1500;

export default function useHelpGuideNavigation() {
  const [highlightedSectionId, setHighlightedSectionId] = useState("");
  const highlightTimeoutRef = useRef(null);

  useEffect(
    () => () => {
      if (highlightTimeoutRef.current) {
        clearTimeout(highlightTimeoutRef.current);
        highlightTimeoutRef.current = null;
      }
    },
    []
  );

  const scrollToSection = useCallback((anchorId) => {
    if (!anchorId || typeof document === "undefined") return false;
    const target = document.getElementById(anchorId);
    if (!target) return false;
    target.scrollIntoView({ behavior: "smooth", block: "start" });
    return true;
  }, []);

  const jumpToSectionWithHighlight = useCallback(
    (anchorId) => {
      const jumped = scrollToSection(anchorId);
      if (!jumped) return;
      setHighlightedSectionId(anchorId);
      if (highlightTimeoutRef.current) {
        clearTimeout(highlightTimeoutRef.current);
      }
      highlightTimeoutRef.current = setTimeout(() => {
        setHighlightedSectionId((current) => (current === anchorId ? "" : current));
      }, HIGHLIGHT_DURATION_MS);
    },
    [scrollToSection]
  );

  const getSectionClassName = useCallback(
    (anchorId) =>
      highlightedSectionId === anchorId
        ? "ring-2 ring-rose-300 ring-offset-2 transition-shadow duration-200"
        : "",
    [highlightedSectionId]
  );

  return {
    highlightedSectionId,
    jumpToSectionWithHighlight,
    getSectionClassName,
  };
}
